<mat-accordion [multi]="true" *ngIf="agreements && agreements.length > 0">
  <mat-expansion-panel class="no-styling" [expanded]="openExpansionPanel$ | async">
    <mat-expansion-panel-header [collapsedHeight]="'*'" [expandedHeight]="'*'">
      <div class="order-details__list-item row">
        <div class="detail-left-col">
          {{ 'FRONTEND.SALES_UI.LAST_ACCEPTED' | translate }}
        </div>
        <div class="order-details__list-item__value show-line-breaks">
          {{ approvalDate }}
        </div>
      </div>
    </mat-expansion-panel-header>
    <ng-container>
      <mat-list dense>
        <mat-list-item *ngFor="let agreement of agreements; last as isLast">
          <div [ngSwitch]="agreement.agreed">
            <mat-icon *ngSwitchCase="true" class="agreement-accepted">check_circle_outline</mat-icon>
            <mat-icon *ngSwitchCase="false" class="agreement-not-accepted">highlight_off</mat-icon>
          </div>
          <div class="agreement-term">
            <p [innerHTML]="agreement.term"></p>
            <p *ngIf="agreement.name">
              <b>{{ 'COMMON.ORDER_DETAILS.SUBMITTED_BY' | translate }}</b>
              {{ agreement.name }}
            </p>
          </div>
          <mat-divider *ngIf="!isLast"></mat-divider>
        </mat-list-item>
      </mat-list>
    </ng-container>
  </mat-expansion-panel>
</mat-accordion>
